import * as React from "react";

import { Dialog } from "primereact/dialog";
import { Dispatch, useState } from "react";
import { Input } from "./Input";
import { AddMarker } from "../../../assets/icons";
import GoogleMapsSelect from "../../GoogleMapsSelect";

interface inputPrams {
  label: string;
  locationGps: string;
  setLocationGps: Dispatch<string>;
  locationLabel: string;
  setLocationLabel: Dispatch<string>;
  required?: boolean;
  error?: string;
}

export function LocationPicker(params: inputPrams) {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      {params.label && (
        <label className="block mb-2">
          {params.label}
          {params.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className={"flex items-center"}>
        <div
          style={{
            background: "#06b6d4",
            height: "50px",
            width: "50px",
            padding: "4px",
            borderBottomLeftRadius: "6px",
            borderTopLeftRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className={"cursor-pointer"}
          onClick={e => setVisible(true)}
        >
          <AddMarker height={28} width={28} fill={"#FFF"} />
        </div>
        <Input
          value={params.locationLabel}
          onChange={e => params.setLocationLabel(e.target.value)}
          type="text"
          placeholder="Please enter address"
          fieldClassName={"w-full"}
          error={params.error}
        />
      </div>

      <Dialog
        header="Select Location"
        visible={visible}
        style={{ width: "50vw", height: "100vh" }}
        onHide={() => setVisible(false)}
      >
        <GoogleMapsSelect
          setVisable={setVisible}
          locationLabel={params.locationLabel}
          locationGps={params.locationGps}
          setLocationGps={params.setLocationGps}
          setLocationLabel={params.setLocationLabel}
        />
      </Dialog>
    </div>
  );
}
